import { gql, useLazyQuery } from "@apollo/client";

const GET_CORPORATION_CATEGORY = gql`
  query getCorporationCategory($input: GetCorporationCategoryInput!) {
    getCorporationCategory(input: $input) {
      ok
      err
      subCategories{
        id
        name  
      }
    }
  }
`;

export interface GetCorporationCategoryInput {
  corporationId: number;
}

export interface GetCorporationCategory {
  getCorporationCategory: {
    ok: boolean;
    err: string;
    subCategories: {
      id: string;
      name: string;
    }[];
  };
}

export const useGetCorporationCategory = (
  onCompleted?: (data: GetCorporationCategory) => void
) => {
  return useLazyQuery<GetCorporationCategory>(GET_CORPORATION_CATEGORY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};